import { IRecordAboutProps, RecordAbout } from "components/RecordAbout";
import { BadgeRecordCounters } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IProps extends IRecordAboutProps {
    counters: BadgeRecordCounters;
}

////////////////////////////////////////////////////////////////////////////////

export const BadgeAbout: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <RecordAbout
            {...props}
            otherInfo={
                <>
                    {
                        props.counters.won > 0 && props.counters.uniqueWon > 0 &&
                        <>
                            <br />
                            {t("Views.Gamification.Components.BadgeAbout.Won1Text", { count: props.counters.won })}
                            {t("Views.Gamification.Components.BadgeAbout.Won2Text", { count: props.counters.uniqueWon })}
                        </>
                    }
                    {
                        props.counters.lastWon &&
                        <>
                            <br />
                            {t("Views.Gamification.Components.BadgeAbout.LastWonText", { lastWon: props.counters.lastWon })}
                        </>
                    }
                </>
            }
        />
    );
};